import { RefObject } from "react";
import type { VariantType } from "../variant/VariantControl";

enum StylingModalType {
  None = 0,
  Border = 1,
  Fill = 2,
  TextColor = 3,
}

const modalTypeToTitle: Record<StylingModalType, string> = {
  [StylingModalType.None]: "",
  [StylingModalType.Border]: "Border",
  [StylingModalType.Fill]: "Fill",
  [StylingModalType.TextColor]: "Text Color",
};

type ModalState = {
  type: StylingModalType;
  anchor?: RefObject<HTMLElement>;
  variant?: VariantType;
};

export type { ModalState };
export { modalTypeToTitle, StylingModalType };
